import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ensureHomeData } from './feature-access';

export const billingGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const homeData = await ensureHomeData();

  if (homeData?.hasBilling === true) {
    return true;
  }

  return router.parseUrl('/home');
};
